import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { css } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { BuilderBlocks } from '@builder.io/react';
import { Tabs } from '@zapier/design-system';
import { useTracking } from '../../tracking';
import { Section } from '../Section';
import { innerText } from './utils';
import { mediaQueries } from '../../constants';
const Styles = labelStyles('TabsSection', {
    navContent: css({
        overflowX: 'auto',
    }),
    tabContent: css({
        overflowX: 'auto',
        paddingTop: '30px',
        [mediaQueries.tablet]: {
            paddingTop: '45px',
        },
        [mediaQueries.desktop]: {
            paddingTop: '55px',
        },
    }),
});
export function TabsSection(props) {
    const root = useRef(null);
    const { navItems, content } = props.tabs.reduce((result, tab, index) => {
        const id = tab.id || tab.heading.toLowerCase().replace(/\s/g, '-');
        const href = `#${id}`;
        return {
            navItems: [...result.navItems, { href, text: tab.heading }],
            content: Object.assign(Object.assign({}, result.content), { [href]: (_jsx(BuilderBlocks, { blocks: tab.content, dataPath: `component.options.tabs.${index}.content`, parentElementId: props.builderBlock.id })) }),
        };
    }, { navItems: [], content: {} });
    const [selectedTabHref, setSelectedTabHref] = useState(navItems[0].href);
    const contentHref = typeof window !== 'undefined' && (content === null || content === void 0 ? void 0 : content[window.location.hash])
        ? window.location.hash
        : navItems[0].href;
    useEffect(() => {
        setSelectedTabHref(contentHref);
    }, [contentHref]);
    useEffect(() => {
        if (window.location.hash &&
            Object.prototype.hasOwnProperty.call(content, window.location.hash) &&
            root.current) {
            root.current.scrollIntoView();
        }
    }, [content]);
    const { emitUserInteractionEvent } = useTracking();
    const handleTabChange = (tab, event) => {
        event.preventDefault();
        setSelectedTabHref(tab.href);
        if (props.changeUrlOnTabChange) {
            window.location.hash = tab.href;
        }
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'tab_change',
            interaction_raw_text: innerText(tab.text),
            option_selected: innerText(tab.text),
        });
    };
    return (_jsx("div", Object.assign({ ref: root }, { children: _jsxs(Section, Object.assign({ heading: props.heading, subheading: props.subheading }, { children: [_jsx("div", Object.assign({ css: Styles.navContent }, { children: _jsx(Tabs, { items: navItems, onChooseItem: handleTabChange, selectedItemHref: selectedTabHref }) })), _jsx("div", Object.assign({ css: Styles.tabContent }, { children: content[selectedTabHref] }))] })) })));
}
//# sourceMappingURL=TabsSection.js.map